<div class="mb-3">
  @if (isReadOnly) {
    <div>
      <p class="form-label">{{ label }}</p>
      <div>{{ readOnlyData }}</div>
    </div>
  }
  @if (!isReadOnly) {
    <div>
      @if (label != null) {
        <label>{{ label }}</label>
      }
      @if (showRequired) {
        <span class="required-indicator">*</span>
      }
      <div class="ui-fluid">
        <p-multiSelect
          defaultLabel="Not Selected"
          [options]="options"
          [filter]="searchFilter"
          [formControl]="control"
          [resetFilterOnHide]="searchFilter"
          [fluid]="true"
        ></p-multiSelect>
      </div>
      @if (control.invalid) {
        <span class="help-block">
          <span class="required-indicator">
            {{ getErrorMessage() }}
          </span>
        </span>
      }
    </div>
  }
</div>
